/******************************************************************
 * Archivo : client/src/queries/dinamico/fetchDynamicSurveys.js
 * Proyecto: CB30
 * Módulo  : Visor Dinámico
 *
 * Propósito:
 * Obtener todas las encuestas disponibles para la primera pantalla
 * del Visor Dinámico.
 *
 * Regla:
 * - No modifica ni reemplaza las queries existentes.
 * - No filtra por published.
 ******************************************************************/

import gql from "graphql-tag";

export default gql`
  query DynamicSurveysQuery {
    surveys {
      id
      titulo
      descripcion
    }
  }
`;




// WEBPACK FOOTER //
// ./src/queries/dinamico/fetchDynamicSurveys.js